import { colors } from "shared/styles/constants";
import { Checkmark, Warning, Error, Info } from "shared/assets/icons";
import { IStatus } from "shared/types";

export const getStatus = (
  status?: IStatus
): {
  color: colors;
  textColor: colors;
  buttonTextColor?: colors;
  bgColor: colors;
  hoverColor?: colors | string;
  icon?: React.ComponentType<any>;
  iconColor?: colors;
} => {
  switch (status) {
    case IStatus.error:
      return {
        color: colors.red,
        textColor: colors.redLight,
        buttonTextColor: colors.white,
        bgColor: colors.red,
        icon: Error,
        iconColor: colors.red,
      };
    case IStatus.warning:
      return {
        color: colors.yellow,
        textColor: colors.yellowLight,
        buttonTextColor: colors.extraBlack,
        bgColor: colors.yellow,
        icon: Warning,
        iconColor: colors.yellow,
      };
    case IStatus.success:
      return {
        color: colors.green,
        textColor: colors.greenLight,
        buttonTextColor: colors.white,
        bgColor: colors.green,
        icon: Checkmark,
        iconColor: colors.green,
      };
    case IStatus.info:
      return {
        color: colors.blue,
        textColor: colors.blueLight,
        buttonTextColor: colors.white,
        bgColor: colors.blue,
        icon: Info,
        iconColor: colors.blue,
      };
    default:
      return {
        color: colors.white,
        textColor: colors.grey5,
        buttonTextColor: colors.white,
        bgColor: colors.grey4,
        iconColor: colors.grey5,
      };
  }
};
